import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getMaxCLASettingById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetRowData = (rowId?: number | null) => {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery({
    queryKey: ['MaxCLASetting', 'get', rowId],
    queryFn: async () => {
      const { data } = await getMaxCLASettingById(rowId);
      return data;
    },
    enabled: !!rowId,
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('max_buh.errors.errorDuringFetching')
      });
    }
  });

  return { isFetching, data };
};

export default useGetRowData;
